<div class="ldap-settings-container">
  <div class="d-flex justify-content-end align-items-center mb-3">
    <button *ngIf="canManage" type="button" class="btn ca-btn ca-btn-neutral" (click)="openModal()">
      + {{ 'Settings::LdapServer:AddServer' | abpLocalization }}
    </button>
  </div>

  <div class="ldap-server-list">
    <table
      mat-table
      [dataSource]="dataSource"
      matSort
      (matSortChange)="sortData($event)"
      [matSortDisableClear]="true">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="name">
          {{ 'CA::Name' | abpLocalization }}
        </th>
        <td mat-cell *matCellDef="let server">{{ server.name }}</td>
      </ng-container>

      <ng-container matColumnDef="serverUrl">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'Settings::LdapServer:ColumnServer' | abpLocalization }}
        </th>
        <td mat-cell *matCellDef="let server">{{ getServerUrl(server) }}</td>
      </ng-container>

      <ng-container matColumnDef="enabled">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'CA::Status' | abpLocalization }}
        </th>
        <td mat-cell *matCellDef="let server">
          <span class="badge" [ngClass]="server.enabled ? 'bg-success' : 'bg-secondary'">
            {{
              (server.enabled
                ? 'Settings::LdapServer:StatusEnabled'
                : 'Settings::LdapServer:StatusDisabled'
              ) | abpLocalization
            }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let server">
          <button
            *ngIf="canManage"
            type="button"
            class="btn ca-btn ca-btn-neutral btn-sm"
            (click)="$event.stopPropagation(); openModal(server)">
            {{ 'Settings::LdapServer:EditServer' | abpLocalization }}
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="info">
        <td mat-footer-cell *matFooterCellDef [attr.colspan]="displayedColumns.length">
          <mat-paginator
            (page)="onPageChange($event)"
            [pageIndex]="currentPage"
            [length]="totalCount"
            [pageSize]="pageSize"
            class="paginator"
            hidePageSize
            showFirstLastButtons></mat-paginator>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row (dblclick)="openModal(row)" *matRowDef="let row; columns: displayedColumns"></tr>
      <tr mat-footer-row *matFooterRowDef="['info']; sticky: true"></tr>
      <tr class="mat-row" *matNoDataRow [hidden]="isLoading">
        <td class="mat-cell" [colSpan]="displayedColumns.length">
          {{ 'Settings::LdapServer:NoServers' | abpLocalization }}
        </td>
      </tr>
    </table>
  </div>
</div>

<ng-template #serverModal let-modal>
  <form [formGroup]="serverForm" (ngSubmit)="saveServer()" validateOnSubmit>
    <div class="modal-header">
      <h5 class="modal-title">
        {{
          (isEditing ? 'Settings::LdapServer:EditServer' : 'Settings::LdapServer:AddServer')
            | abpLocalization
        }}
      </h5>
      <button type="button" class="btn-close" (click)="closeModal()"></button>
    </div>
    <div class="modal-body">
      <div class="row mb-2">
        <div class="col-sm-12">
          <span class="indicates-required-field-info">
            {{ '::IndicatesRequiredField' | abpLocalization }}
          </span>
        </div>
      </div>
      <div class="row mb-3">
        <label class="col-sm-3 col-form-label col-form-label-sm indicates-required-field">
          {{ 'CA::Name' | abpLocalization }}
        </label>
        <div class="col-sm-9">
          <input type="text" class="form-control form-control-sm" formControlName="name" />
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-sm-9 offset-sm-3 d-flex gap-4">
          <div class="form-check">
            <input
              type="checkbox"
              class="form-check-input"
              id="enabled"
              formControlName="enabled" />
            <label class="form-check-label" for="enabled">
              {{ 'Settings::LdapServer:StatusEnabled' | abpLocalization }}
            </label>
          </div>
          <div class="form-check">
            <input
              type="checkbox"
              class="form-check-input"
              id="ldapOverSsl"
              formControlName="ldapOverSsl" />
            <label class="form-check-label" for="ldapOverSsl">
              {{ 'Settings::LdapServer:LdapOverSsl' | abpLocalization }}
            </label>
          </div>
        </div>
      </div>

      <div class="row mb-3">
        <label class="col-sm-3 col-form-label col-form-label-sm indicates-required-field">
          {{ 'Settings::LdapServer:ServerHost' | abpLocalization }}
        </label>
        <div class="col-sm-6">
          <input type="text" class="form-control form-control-sm" formControlName="serverHost" />
        </div>
        <label class="col-sm-1 col-form-label col-form-label-sm text-nowrap px-0 indicates-required-field">
          {{ 'Settings::LdapServer:Port' | abpLocalization }}
        </label>
        <div class="col-sm-2">
          <input
            type="number"
            class="form-control form-control-sm"
            formControlName="port"
            min="1"
            max="65535" />
        </div>
      </div>

      <div class="row mb-3">
        <label class="col-sm-3 col-form-label col-form-label-sm">
          {{ 'Settings::LdapServer:BindUsername' | abpLocalization }}
        </label>
        <div class="col-sm-9">
          <input type="text" class="form-control form-control-sm" formControlName="bindUsername" />
        </div>
      </div>

      <div class="row mb-3">
        <label class="col-sm-3 col-form-label col-form-label-sm">
          {{ 'Settings::LdapServer:Password' | abpLocalization }}
        </label>
        <div class="col-sm-9">
          <input type="password" class="form-control form-control-sm" formControlName="password" />
        </div>
      </div>

      <div class="row mb-3">
        <label class="col-sm-3 col-form-label col-form-label-sm">
          {{ 'Settings::LdapServer:LdapDomainName' | abpLocalization }}
        </label>
        <div class="col-sm-9">
          <input
            type="text"
            class="form-control form-control-sm"
            formControlName="ldapDomainName" />
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-sm-9 offset-sm-3 d-flex gap-4">
          <div class="form-check">
            <input
              type="checkbox"
              class="form-check-input"
              id="skipCertificateValidation"
              formControlName="skipCertificateValidation" />
            <label class="form-check-label" for="skipCertificateValidation">
              {{ 'Settings::LdapServer:SkipCertificateValidation' | abpLocalization }}
            </label>
          </div>
          <div class="form-check">
            <input
              type="checkbox"
              class="form-check-input"
              id="autoVerifyUsers"
              formControlName="autoVerifyUsers" />
            <label class="form-check-label" for="autoVerifyUsers">
              {{ 'Settings::LdapServer:AutoVerifyUsers' | abpLocalization }}
            </label>
          </div>
        </div>
      </div>

      <div class="row mb-3">
        <label class="col-sm-3 col-form-label col-form-label-sm">
          {{ 'Settings::LdapServer:CertificateName' | abpLocalization }}
        </label>
        <div class="col-sm-9">
          <input
            type="text"
            class="form-control form-control-sm"
            formControlName="certificateName" />
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button
        *ngIf="isEditing && canManage"
        type="button"
        class="btn btn-sm btn-danger me-auto"
        [disabled]="isSaving"
        (click)="deleteServer()">
        {{ 'CA::Delete' | abpLocalization }}
      </button>
      <button
        type="button"
        class="btn ca-btn ca-btn-neutral"
        [disabled]="isSaving"
        (click)="closeModal()">
        {{ 'AbpUi::Cancel' | abpLocalization }}
      </button>
      <button
        *ngIf="canManage"
        type="submit"
        class="btn ca-btn ca-btn-primary"
        [disabled]="isSaving">
        <i class="fas fa-spinner fa-spin me-1" *ngIf="isSaving"></i>
        <i class="far fa-save" *ngIf="!isSaving"></i>
        <span>{{ 'CA::Save' | abpLocalization }}</span>
      </button>
    </div>
  </form>
</ng-template>